import { Button } from "antd";
import styled from "styled-components";

export const Inner = styled.div`
	display: flex;
	min-height: 200px;
	justify-content: flex-start;
	align-items: center;
	flex-direction: column;
	gap: 20px;
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	width: ${(props) => (props.isMobile ? "100%" : "70%")};
	gap: 20px;
`;

export const Section = styled.div`
	${(props) =>
		props.isMobile
			? `
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 10px;
    justify-content: space-between;
    align-items: center;
  `
			: `
    display: flex;
    width: 100%;
    gap: 10px;
    justify-content: space-between;
    align-items: top;
  `}
`;

export const AntdButton = styled(Button)`
	border-radius: 10px;
	padding: 40px 20px;
	display: flex;
	flex-direction: column;
	width: 100px;
`;
